import { ProfileState, ProfileFilters } from './interfaces';

export const initialFilters: ProfileFilters = {
  userName: '',
  careerMentorIds: null,
};

export const teamProfilesInitialState: ProfileState = {
  items: [],
  loading: false,
  filters: { ...initialFilters },
  pagination: {
    limit: 0,
    page: 1,
    total: 0,
  },
  init: false,
  fullData: {},
  careerMentorOptions: [],
  hasSharedScorecards: false,
};

export const storeName = 'teamProfiles' as const;

export type ProfileStoreName = typeof storeName;
